import { getIsAuth } from "@selectors/auth";

import { useAppSelector } from "@hooks/store";

export const useIsAuth = () => {
  const isAuth = useAppSelector(getIsAuth);

  return isAuth;
};
